module.exports = __webpack_public_path__ + "static/media/up.52fc107e.svg";